<template>
    <div>

        <b-tabs pills card horizontal class="promocao">
            <b-tab v-for="(regulamento, index) in promocoesComTermo"
                   :active="index == indexTabRegulamento"
                   :disabled="index != indexTabRegulamento ? true : false">
                <template v-slot:title>
                    <b-media>
                        <p class="mb-0">
                            <strong>{{regulamento.nomePromocao}}</strong><br />
                        </p>
                    </b-media>
                </template>

                <b-card-text>
                    <div class="row row-cols-1 row-cols-md-3">
                        <div class="col mb-4 p-2">
                            <div class="card h-100 shadow-custom">

                                <div class="card-body select-promocao px-2 py-3">
                                    <h5 class="text-primary card-title"><strong>{{regulamento.nomeDestinatario}}</strong></h5>
                                    <hr />

                                    <div class="bg-light p-1" v-html="regulamento.regulamento">

                                    </div>
                                </div>
                                <div class="card-footer">
                                    <input type="checkbox" value="aceito" @click="aceito = !aceito" required />
                                    Estou de acordo.
                                </div>

                            </div>
                        </div>
                    </div>

                </b-card-text>

                <button type="button" class="btn btn-outline-danger float-left" @click="returnHome()">
                    <span>Voltar para home</span>
                </button>

                <button type="button" v-if="aceito" class="btn btn-outline-success float-right" @click="salvarPromocaoRegulamentoPessoa(regulamento, index)">
                    <span>Confirmar</span>
                </button>
                <button type="button" v-if="!aceito" class="btn btn-outline-success float-right" disabled>
                    <span>Confirmar</span>
                </button>

            </b-tab>

        </b-tabs>
    </div>
</template>
<script>
    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: 'promocaoaceite',
        components: {},
        mixins: [base],
        props: { promocoesComTermo: Array },
        data() {
            return {
                aceito: false,
                indexTabRegulamento: 0,
                dadosRegulamento: null,
            }
        },
        methods: {
            returnHome() {
                window.location = "/home"
            },
            //confirmarAceite() {
            //    if (this.aceito)
            //        this.$emit('on-confirmaAceite');
            //    else {
            //        this.defaultErrorResult("É necessário aceitar o Termo para continuar a compra", true);
            //    }
            //},
            onBack() {
                this.$emit('on-back')
            },
            salvarPromocaoRegulamentoPessoa: function (regulamento) {
                
                    new Api("promocaoregulamentopessoa").post({ promocaoId: regulamento.promocaoId, pessoaId: regulamento.pessoaId }).then(result => {
                        this.indexTabRegulamento += 1;
                        this.aceito = false;
                        if (this.promocoesComTermo.length == this.indexTabRegulamento) {
                            this.onBack();
                            this.indexTabRegulamento = 0;
                        }
                    }, err => {
                        this.defaultErrorResult(err, true);
                    })               

            },

        },
        mounted() {

            //console.log("populei meu array", this.promocoesComTermo)
            
        }
    };
</script>
<style>
    .background-frete {
        background-color: #7E0005;
    }

    @media (min-width: 1200px) {
        .modal-xl {
            max-width: 1140px;
        }
    }
</style>
